import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Table, Typography } from 'antd'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../../core/helpers'
import { formatDateUk } from '../../../core/utils'

import { SCRAPING_REVIEW_COMMENT_TYPE } from '../../constants'
import { useScrapingReviewCommentsQuery } from '../../hooks'
import { StyledHistoryModal } from '../styled'

const ScrapingReviewCommentsModal = ({ menuCurationTaskId }) => {
  const [isVisible, setIsVisible] = useState(false)

  const { data, isLoading, error } =
    useScrapingReviewCommentsQuery(menuCurationTaskId)

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Failed to get scraping review comments',
        description: error,
      })
    }
  }, [error])

  const content = useMemo(() => {
    const columns = [
      {
        title: 'Comment',
        key: 'text',
        render: ({ text, type }) => {
          if (type === SCRAPING_REVIEW_COMMENT_TYPE.COMMENT) {
            return text
          }

          return <Typography.Text type="secondary">{text}</Typography.Text>
        },
      },
      {
        title: 'User',
        dataIndex: 'user',
        key: 'user',
        render: user => user?.name,
      },
      {
        title: 'Created at',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: date => date && formatDateUk(date),
      },
    ]

    return (
      <Table
        columns={columns}
        size="small"
        loading={isLoading}
        rowKey="id"
        dataSource={data}
      />
    )
  }, [isLoading, data])

  const handleCancel = useCallback(() => setIsVisible(false), [])
  const toggleModal = useCallback(() => setIsVisible(!isVisible), [isVisible])

  return (
    <>
      <StyledHistoryModal
        title="Scraping review comments"
        footer={null}
        visible={isVisible}
        onCancel={handleCancel}
      >
        {content}
      </StyledHistoryModal>
      <Button type="link" onClick={toggleModal}>
        {' '}
        View detailed comments{' '}
      </Button>
    </>
  )
}

ScrapingReviewCommentsModal.propTypes = {
  menuCurationTaskId: PropTypes.string.isRequired,
}

export default ScrapingReviewCommentsModal
